import { render } from "./DaycareClass.vue?vue&type=template&id=8d677860&scoped=true&ts=true"
import script from "./DaycareClass.vue?vue&type=script&lang=ts"
export * from "./DaycareClass.vue?vue&type=script&lang=ts"

import "./DaycareClass.vue?vue&type=style&index=0&id=8d677860&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d677860"]])

export default __exports__